import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
// import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';
import { Message, Transition, Dimmer, Loader } from 'semantic-ui-react';
import { log } from '@emyw/core-lib';
import Step2VerifyResult from '@emyw/subscribe-lib/Step2VerifyResult';
import { ValidateStep } from './index';
// import * as userActions from '../actions/userActions';
import { loadUser } from '../actions/userActions';
import { withAppContext } from '../AppContext';
// import VerifiedAccount from './VerifiedAccount';
// import { ButtonLink } from '@emyw/auth-lib';

const { REACT_APP_FREE_PLAN_CODE: FREE, REACT_APP_SKIP_EMAIL_VERIFICATION } = process.env;
const SKIP_EMAIL_VERIFICATION = REACT_APP_SKIP_EMAIL_VERIFICATION === 'true';

class VerifyAccount extends Component {
    state = {
        proceedTo: undefined,
        reloadingUser: false, // used to ensure that the user is reloaded in redux state after setting the plan before proceeding
        error: undefined,
        // verificationSuccess: false,
    }

    componentWillMount() {
        const { context } = this.props;
        const { user } = context.state;
        ValidateStep(window.location, user).then((directTo) => {
            if (directTo !== 'verifyaccount') this.setState({ proceedTo: directTo });
        });
        context.setAppState({ currentStep: 'account' });
    }

    /* componentWillReceiveProps(nextProps) {
        log.trace(nextProps.user.verifiedOn);
        if (this.state.reloadingUser && nextProps.user.verifiedOn) {
            this.setState({ reloadingUser: false, proceedTo: 'payment' });
        } else {
            // we didn't get a verified account as expected
            this.setState({ reloadingUser: false, error: 'The user could not be verified. Unknown error.' });
        }
    } */

    determineNextStep = (planCode) => {
        if (!planCode) {
            this.setState({ proceedTo: 'plan' });
        } else if (planCode === FREE) {
            this.setState({ proceedTo: 'confirm' });
        } else {
            this.setState({ proceedTo: 'payment' });
        }
    }

    updateUser = (user) => {
        const { context } = this.props;
        log.trace('user:', user, SKIP_EMAIL_VERIFICATION);
        if ((user || {}).verifiedOn || SKIP_EMAIL_VERIFICATION) {
            context.setAppState({ user });
            /* Use stored plan code rather than user.subscriptionLevelCode, as a different plan may have been selected */
            const planCode = localStorage.getItem('plan-code');

            /* Now that we have verified the account, we can remove some of the storage we were holding onto */
            const socialUser = sessionStorage.getItem('social-user');
            sessionStorage.removeItem('user-form-values');
            sessionStorage.removeItem('social-user');
            localStorage.removeItem('verification-email');
            localStorage.removeItem('enjoy-signup-progress');
            localStorage.removeItem('plan-code');
            const tokenExists = window.location.search !== '';
            if (tokenExists) {
                this.setState({ proceedTo: 'verifiedaccount' });
            } else if (
                !SKIP_EMAIL_VERIFICATION
                || !(user || {}).verifiedOn
                || socialUser
                || ((user || {}).verifiedOn && !tokenExists)
            ) {
                this.determineNextStep(planCode);
            // } else if ((user || {}).verifiedOn) {
            //     this.setState({ reloadingUser: false, verificationSuccess: true, error: null });
            } else {
                this.setState({ reloadingUser: false, error: 'The user could not be verified. Unknown error.' });
            }
        } else {
            /* We didn't get a verified account as expected */
            this.setState({ reloadingUser: false, error: 'The user could not be verified. Unknown error.' });
        }
    }

    handleVerificationSuccess = () => {
        log.trace('verification success!');
        /* We expect to have auth tokens at this point, so load user state */
        this.setState({ reloadingUser: true }); // proceedTo: 'payment' });
        // this.props.actions.loadUser('network-only');
        (loadUser('network-only'))(({ user }) => {
            log.trace('updated user:', user);
            this.updateUser(user);
        });
    }

    handleReturnToCreateAccount = () => {
        const { context } = this.props;
        const { disableSocialLogin } = context.state;
        this.setState({ proceedTo: disableSocialLogin ? 'newaccount' : 'setupaccount' });
    }

    render() {
        const { context } = this.props;
        const { user } = context.state;
        const { proceedTo, reloadingUser, error } = this.state;

        if (proceedTo) {
            log.trace('this.state.proceedTo:', proceedTo);
            return <Redirect to={`/signup/${proceedTo}`} />;
        }

        // log.trace('verify account state user:', user);
        const tokenExists = window.location.search !== '';
        const socialUser = JSON.parse(sessionStorage.getItem('social-user'));
        const userFormValues = JSON.parse(sessionStorage.getItem('user-form-values'));
        // log.trace(user || userFormValues || socialUser || {});
        // log.trace(userFormValues);
        // log.trace(socialUser);
        const currentEmail = (user || userFormValues || socialUser || {}).email;
        let verificationEmail = localStorage.getItem('verification-email');
        if (verificationEmail === 'undefined') verificationEmail = undefined;

        if (!verificationEmail || (currentEmail && currentEmail !== verificationEmail)) {
            // place the verification email into localstorage for preservation should the verification link be clicked
            verificationEmail = currentEmail;
            localStorage.setItem('verification-email', verificationEmail);
        }
        log.trace('verificationEmail, tokenExists', verificationEmail, tokenExists);

        if (!verificationEmail && !tokenExists) {
            return (
                /* eslint-disable react/jsx-one-expression-per-line */
                <div
                    /* Match subscribe lib's width restraint: */
                    className="wizardStepBase"
                    style={{ margin: '0 auto' }}
                >
                    <Helmet>
                        <title>Enjoy Signup - Verify Account</title>
                        <meta name="description" content="Verify account" />
                    </Helmet>
                    Sorry, code verification won&apos;t work here.<br />
                    No problem, just try clicking the link in the email we sent earlier to verify your account.<br /><br />
                    Or <Link onClick={() => localStorage.removeItem('enjoy-signup-progress')} to="/signup/">try again</Link>.
                </div>
                /* eslint-enable react/jsx-one-expression-per-line */
            );
        }
        return (
            <div style={{ maxWidth: '615px', margin: '0 auto' }}>
                <Helmet>
                    <title>Enjoy Signup - Verify Account</title>
                    <meta name="description" content="Verify Account" />
                </Helmet>
                {(reloadingUser) && (
                    <Transition visible={reloadingUser} animation="scale" duration={500}>
                        <Dimmer active/* inverted */>
                            {/* eslint-disable-next-line react/jsx-tag-spacing */}
                            <Loader /* inverted */>One Moment...</Loader>
                        </Dimmer>
                    </Transition>
                )}
                <Step2VerifyResult
                    {...this.props}
                    onVerificationSuccess={this.handleVerificationSuccess}
                    onChangeEmail={this.handleReturnToCreateAccount}
                    verificationEmail={verificationEmail}
                    onTryAgain={this.handleReturnToCreateAccount}
                    codeEntryMode
                    skipVerification={SKIP_EMAIL_VERIFICATION} // added 5/30/2020 - CSM
                />
                {error ? (
                    <Message
                        size="small"
                        error
                        header="Trouble validating code..."
                        content={error}
                    />
                ) : null
                }
            </div>
        );
    }
}

// const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(userActions, dispatch) });
// const mapStateToProps = state => ({ user: state.user });

// export default connect(mapStateToProps, mapDispatchToProps)(VerifyAccount);
export default withAppContext(VerifyAccount);
